import { useEffect } from "react";
import { gsap } from "gsap";

function FloatAnimation(ref) {
  useEffect(() => {
    gsap.to(ref.current, {
      y: "+=5px",
      repeat: -1,
      yoyo: true,
      duration: 1,
      ease: "power2.inOut",
    });
  }, [ref]);
}

export default FloatAnimation;
